<div class="card rounded-3">

    <div class="card-header border-0 bg-white rounded-3">
        <span class="fw-bolder">
            {{ query() }}
        </span>
        <fa-icon class="float-end" [icon]="faCircle" style="font-size: 1rem; color: #0033A1;"></fa-icon>
    </div>

    <div class="card-body">

        @if (answer(); as answer) {
        <div class="d-flex flex-row">
            <div>
                <img src="images/Favicon-Tim-48x48.ico" alt="Tim Logo" style="width:32px; height:32px;">
            </div>
            <div class="ps-2">
                @if (answerWithCitations(); as answerWithCitations) {
                    <span [innerHTML]="answerWithCitations" class="fade-in"></span>
                } 
                @else {
                    <div [innerHTML]="answer | markdown | async" class="fade-in"></div>
                }
            </div>
        </div>

        <ng-content></ng-content>
        }

        @if (loading()) {
        <app-animated-loading class="d-flex align-items-center"></app-animated-loading>
        }

    </div>

</div>